import React, { useState } from "react";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./styles/breakpoints.css";
import "./styles/responsive-utils.css";
import "./styles/App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import { isAuthenticated, logout } from "./Utils/auth";
import InactivityModal from "./Componentes/InactivityModal";
import ProtectedRoute from "./Componentes/RutasProtegidas";
import ListaClientes from "./Pages/ListaClientes";
import Paises from "./Pages/Paises";
import Login from "./Pages/Login";
import CrearCliente from "./Pages/CrearClientes";
import ListaContenedores from "./Pages/ListaContenedores";
import ListaPedidos from "./Pages/ListaPedidos";
import ListaPedidosHistorico from "./Pages/Historico";
import HistoricoContenedores from "./Pages/HistoricoContenedores";
import BillOfLading from "./Pages/ListaBillOfLading";
import "primereact/resources/themes/fluent-light/theme.css";
import "./styles/docontrol-theme.css";
import "primeflex/primeflex.css";
import useInactivityDetector from "./Componentes/useInactivityDetector";
import { useActivityLogger } from "./Utils/useActivityLogger";

function App() {
  /* --- INICIO INTEGRACIÓN LOGGER --- */
  // 'debug: true' imprimirá los logs en la consola (F12) para que verifiques que funciona.
  // Cuando termines de probar, cambia a 'debug: false'.
  const { getLogs } = useActivityLogger({ enable: true, debug: true });
  // Opcional: Hacerlos accesibles globalmente para pruebas rápidas en consola escribiendo 'window.DOControlLogs()'
  if (typeof window !== "undefined") {
    window.DOControlLogs = getLogs;
  }
  /* --- FIN INTEGRACIÓN LOGGER --- */
  const [language, setLanguage] = useState("es");
  const [isMenuVisible, setMenuVisible] = useState(true);
  const [authenticated, setAuthenticated] = useState(isAuthenticated());
  const navigate = useNavigate();

  const { isModalVisible, remainingTime, resetTimer } = useInactivityDetector(
    () => {
      logout(navigate);
      setAuthenticated(false);
    },
    authenticated,
  );

  // Manejar el evento beforeunload para cerrar sesión
  /* 
  React.useEffect(() => {
    const handleBeforeUnload = () => {
      // Llama a logout sin redirigir
      logout(null, false);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  */
  // Se ejecuta solo una vez al montar el componente

  // Función para cambiar el idioma
  const setLanguageHandler = (lang) => {
    setLanguage(lang);
  };

  return (
    <>
      <Routes>
        <Route
          index
          element={
            <Login
              language={language}
              onUserLogin={() => setAuthenticated(true)}
            />
          }
        />
        <Route
          path="/login"
          element={
            <Login
              language={language}
              onUserLogin={() => setAuthenticated(true)}
            />
          }
        />
        <Route
          element={
            <ProtectedRoute
              language={language}
              setLanguageHandler={setLanguageHandler}
              isMenuVisible={isMenuVisible}
              onToggleMenu={() => setMenuVisible((prev) => !prev)}
            />
          }
        >
          <Route
            path="/clientes"
            element={<ListaClientes language={language} />}
          />
          <Route
            path="/crearcliente"
            element={<CrearCliente language={language} />}
          />
          <Route path="/paises" element={<Paises language={language} />} />
          <Route
            path="/listacontenedores"
            element={<ListaContenedores language={language} />}
          />
          <Route
            path="/HistoricoContenedores"
            element={<HistoricoContenedores language={language} />}
          />
          <Route
            path="/listapedidos"
            element={<ListaPedidos language={language} />}
          />
          <Route
            path="/historicopedidos"
            element={
              <ListaPedidosHistorico
                language={language} /*  isHistoric={true} */
              />
            }
          />
          <Route
            path="/billoflading"
            element={<BillOfLading language={language} />}
          />
        </Route>
      </Routes>
      {authenticated && (
        <InactivityModal
          visible={isModalVisible}
          onHide={() => resetTimer(true)}
          remainingTime={remainingTime}
        />
      )}
    </>
  );
}

export default App;
